import { FeatureItem, IncludedItemData, StatItem } from "./types";

export const HERO_STATS: StatItem[] = [
  {
    value: "6 in 10",
    label:
      "Homeowners looking to hire an interior designer would prefer the option to finance their project.",
  },
  {
    value: "+20%",
    label:
      "Average increase in project budget when homeowners use financing — more room to realize your full vision.",
  },
  {
    value: "$200K",
    label:
      "Maximum financing available to qualifying clients, covering even the most ambitious residential projects.",
  },
];

export const FEATURES: FeatureItem[] = [
  {
    icon: "clock",
    title: "60-Second Client Application",
    description:
      "Your clients access a co-branded financing page with your identity. The application is simple, fast, and requires no paperwork — complete it in-person, by text, or via link.",
  },
  {
    icon: "check",
    title: "Soft Credit Pull — No Score Impact",
    description:
      "Clients pre-qualify and see their options without any impact to their credit score. The hard pull only occurs when they choose to proceed with a lender.",
  },
  {
    icon: "card",
    title: "30+ Lending Partners",
    description:
      "A single application connects clients to over 30 lenders simultaneously — including Upgrade, LightStream, and PenFed — who compete to offer the best terms.",
  },
  {
    icon: "star",
    title: "Up to $200,000 Per Project",
    description:
      "Loans up to $200,000 at rates as low as 7.99%, with repayment terms up to 15 years. Financing offers vary by lender and applicant.",
  },
  {
    icon: "chart",
    title: "Real-Time Project Dashboard",
    description:
      "Track every client's financing journey in your control panel — accessible on desktop or mobile. Know where each client stands without a phone call.",
  },
  {
    icon: "user",
    title: "Earn Commissions",
    description:
      "You can earn up to $650 for every funded project — unlimited commissions with no dealer fees.",
  },
];

export const INCLUDED_ITEMS: IncludedItemData[] = [
  {
    title: "Enhancify Professional Growth Plan",
    description:
      "Annual plan access tailored for design firms ready to offer financing from day one.",
  },
  {
    title: "Co-Branded Client Financing Portal",
    description:
      "A clean, branded financing experience your clients complete in about 60 seconds.",
  },
  {
    title: "30+ Lender Network Access",
    description:
      "One application, multiple offers — your client compares lender terms in real time.",
  },
  {
    title: "Up to $200K Financing Per Project",
    description:
      "Support projects from focused updates to large-scale transformations.",
  },
  {
    title: "Earn Up to $650 Per Funded Project",
    description:
      "Monetize financing adoption with performance-based commission opportunities.",
  },
  {
    title: "Dedicated Account Manager",
    description:
      "Get onboarding, training, and support to integrate financing into your client process.",
  },
];
